var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ControlOption',{attrs:{"campos":_vm.campos,"camposIndex":_vm.camposIndex}},[_c('v-alert',{staticClass:"my-3",attrs:{"dense":"","dark":"","color":"accent"}},[_c('strong',[_vm._v(" "+_vm._s(_vm.campos.pregunta)+" ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }